import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const EclipseBiEventsExtension = ModuleExtensions.biEventsExtension();
//# sourceMappingURL=eclipse-bi-events.extension.js.map